import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import {PrecompiledJSONItem} from "PDFLib/core/writers/JSONWriter/JSONItem/PrecompiledJSONItem";
import PDFObject from "PDFLib/core/objects/PDFObject";
import {JSONFactory} from "PDFLib/core/writers/JSONWriter/JSONFactory";

export class IndirectObjectJsonItem extends JSONItemBase
{
    public Object:JSONItemBase;
    constructor(public ON:number,public GN:number,value:PDFObject) {
        super();
        this.Object=JSONFactory.GetItem(value);
    }

    GetType() {
        return "IO";
    }

}